module.exports = __webpack_public_path__ + "media/images/info_btn-1fc32a0aaae2ad35980175f8504b2f03.svg";